<h1>{{ context.content }}</h1>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/title/title.component.html